import React from "react";
import styled from "styled-components";
import { Field } from "formik";
import { colors } from "core/stylesheet";

export default props => (
  <Field
    name={props.name}
    value={props.value}
    render={({ field, ...rest }) => (
      <Input {...field} {...props} type="checkbox" checked={!!field.value} />
    )}
  />
);

const Input = styled.input.attrs({
  className: "br1 pointer"
})`
  appearance: none;
  outline: none;
  width: 18px;
  height: 18px;
  top: 4px;
  border: 1px solid #aaa;
  position: relative;
  flex-shrink: 0;
  &:checked:before {
    content: "✔";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.brand};
    font-family: "CircularStd-Book";
    direction: ltr;
    -webkit-font-feature-settings: "liga";
    -webkit-font-smoothing: antialiased;
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/InsidersList/internal/Modal/Checkbox.js